import { useController } from 'react-hook-form';
import { RadioProps, Radio } from 'ui/radio';
import { FieldProps } from './types';

type RadioFieldProps = FieldProps & { radioKey: string; id?: string } & Omit<
    RadioProps,
    'onClick' | 'onKeyDown' | 'value' | 'isChecked' | 'id'
  >;

export const RadioField = ({ id, name, radioKey, ...rest }: RadioFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: false,
  });

  const handleRadioSelection = () => {
    if (radioKey !== value) {
      onChange(radioKey);
    }
  };

  return (
    <Radio
      id={id || `id-${name}`}
      value={radioKey === value}
      onClick={handleRadioSelection}
      onKeyDown={handleRadioSelection}
      isChecked={radioKey === value}
      {...rest}
    />
  );
};
